import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAlgoliaDataQueryId } from 'selectors/algolia2/data'

import { getKeyword, getSeoCategory, getTitle } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  queryID: getAlgoliaDataQueryId,
  category: getSeoCategory,
  title: getTitle,
  keyword: getKeyword,
})

export type ConnectorProps = {
  queryID: string
  category: string
  title: string
  keyword: string
}

export default connect(mapStateToProps)
